import { Mode, Type } from "../Form";
import { TextField } from "../TextField/TextField";
import { TextFieldComponent } from "../TextField/TextFieldComponent";
import styles from "./ShortText.module.scss";

type Options = {question?: string, answer?: string, renderId?: string, required?: boolean};

export class ShortText extends TextField {
  constructor(options?: Options) {
    super({...(options ?? {}), type: Type.ShortTextField});
  }

  render(mode: Mode, onElementChange: (element: ShortText) => void): JSX.Element {
    return <TextFieldComponent key={this.renderId} mode={mode} onElementChange={onElementChange} element={this} />
  }
}